export default __webpack_public_path__ + "static/media/five_stars.ef259a53.svg";